/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Dataset
 */
export interface Dataset {
  /**
   *
   * @type {number}
   * @memberof Dataset
   */
  readonly id: number;
  /**
   *
   * @type {boolean}
   * @memberof Dataset
   */
  hasPredictions?: boolean;
}

/**
 * Check if a given object implements the Dataset interface.
 */
export function instanceOfDataset(value: object): value is Dataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function DatasetFromJSON(json: any): Dataset {
  return DatasetFromJSONTyped(json, false);
}

export function DatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
  };
}

export function DatasetToJSON(value?: Omit<Dataset, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    has_predictions: value['hasPredictions'],
  };
}
